import {Directive, ElementRef, OnInit, OnDestroy, inject, untracked} from '@angular/core';
import {TabPanel} from 'primeng/tabs';
import {SaveButtonTrackingService} from './save-button-tracking.service';
import {TabLocation} from './save-button-tracking.types';

@Directive({
  selector: '[appConfirmStepLeaveDirective]',
})
export class ConfirmStepLeaveDirective implements OnInit, OnDestroy {
  private readonly trackingService = inject(SaveButtonTrackingService);
  private readonly elementRef = inject(ElementRef<HTMLElement>);
  private readonly tabPanel = inject(TabPanel, {optional: true});
  private readonly buttonId = crypto.randomUUID().toString();

  ngOnInit(): void {
    this.trackingService.registerButton(this.buttonId, {
      element: this.elementRef.nativeElement,
      enclosingTabs: this.enclosingTabs(),
    });
  }

  ngOnDestroy(): void {
    this.trackingService.unregisterButton(this.buttonId);
  }

  private enclosingTabs(): TabLocation[] {
    const enclosingTabs: TabLocation[] = [];

    for (let tabPanel = this.tabPanel; tabPanel != null; tabPanel = tabPanel.$pcTabPanel ?? null) {
      const tabValue = untracked(() => tabPanel?.value());

      if (tabValue != null) {
        enclosingTabs.push({tabs: tabPanel.pcTabs, tabValue: String(tabValue)});
      }
    }

    return enclosingTabs;
  }
}
